import { Typography, Button, Box, Stack } from '@mui/material';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { VectorLogo } from '../../../components/VectorLogo';
import { getCameraActions, PageLayout } from '../../../components/PageLayout';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('anonymousPhotoSubmitted.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <Stack spacing={1}>
          <Box sx={{ textAlign: 'center' }}>
            <VectorLogo sx={{ pt: 1 }} />
          </Box>

          <Typography variant="h3" align="center">
            {t('anonymousPhotoSubmitted.success')}
          </Typography>

          <Typography
            sx={{
              marginBottom: '16px',
            }}
          >
            {t('anonymousPhotoSubmitted.description')}
          </Typography>
          <Typography
            sx={{
              marginBottom: '16px',
            }}
          >
            {t('anonymousPhotoSubmitted.warning')}
          </Typography>

          <Button fullWidth size="large" to="/" component={Link}>
            {t('anonymousPhotoSubmitted.button')}
          </Button>
        </Stack>
      </SimplePageLayout>
    </>
  );
};

export const AnonymousPhotoSubmitted = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="AnonymousPhotoSubmittedPage"
      headerBarProps={{
        action: '/',
        title: t('anonymousPhotoSubmitted.title'),
        iconActions: getCameraActions(t),
      }}
    >
      <Content />
    </PageLayout>
  );
};
